import { createContext } from 'react';

export type SignFormContextInfo = {
	insideMobileModal: boolean;
};

export const SignFormContext = createContext<SignFormContextInfo | undefined>(undefined);
